export class ListOfCalendarGroupResponse {
	number: number;
	name: string;
}
